import React from 'react';

interface NavigationButtonsProps {
  onBack?: () => void;
  onNext?: () => void;
  nextDisabled?: boolean;
  nextText?: string;
  backText?: string;
  showBack?: boolean;
  showNext?: boolean;
  alignment?: 'start' | 'center' | 'end' | 'space-between';
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  onBack,
  onNext,
  nextDisabled = false,
  nextText = 'Fortsæt',
  backText = 'Tilbage',
  showBack = true,
  showNext = true,
  alignment = 'space-between'
}) => {
  const alignmentClass = alignment === 'space-between' ? '' : ` form-actions--${alignment}`;

  return (
    <div className={`form-actions${alignmentClass}`}>
      {showBack && onBack && (
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onBack}
        >
          <i className="fa-solid fa-arrow-left"></i>
          {backText}
        </button>
      )}
      {showNext && onNext && (
        <button
          type="button"
          className="btn btn-primary"
          onClick={onNext}
          disabled={nextDisabled}
        >
          {nextText}
          <i className="fa-solid fa-arrow-right"></i>
        </button>
      )}
    </div>
  );
};
